'use strict';
angular
    .module('sysmanageModule', [
        'sysmanageRouterModule',
        'cDMainModule',
        'sysManageMentSensitiveWordModule',
        'manConSysSouCenClassifyMgrModule',
        'manageSysManageEmailConfigModule',
        'manageSysManageSMSGatewayConfigModule',
        'manageSysManageSourceManageModule',
        'manageSysManagePlanDispatchModule',
        'manageSysManageHotWordsManageModule',
        'manageSysManageStatusManageModule',
        'manageSysManageReleaseComponentManageModule',
        'manageSysManageSMSTempConfigModule',
        'manageSysManageEmailTempConfigModule',
        'manageSysManageOtherConfigurationModule',
        'manageSysManageSystemFieldModule',
        'manageSysManageTypeMgrModule',
        'manageSysManageCategoryRelationModule',
        'manageSysManagecomLibraryManagementModule',
        'manageSysManagesystemManagementModule',
        'manageSysManagesyStemPersonalCenterConfigModule',
        'manageSysManagePublicMaterialLibraryModule',
        'manageSysManageSysOperationManagementModule',
        'manageSysManageManuscriptAttributeConfigModule',
        'tenantShareManuscriptModule',
        'cooperationGroupModule',
        'hiddenCodeManagementModule', // 埋码管理
        'systemNoticeModule', // 系统公告
        'manageSysManageContributionQueryModule', // 稿件查询
        'manageSysManageXHContributionAccessRecordsModule', // 新华社稿取用记录
        'manageSysOneKeyWithdrawModule', // 一键快撤
        'manageSysXhsgCircuitModule', // 新华社稿线路配置
        'manageSysManageFeedBackModule', // 意见反馈
        'manageSysManageSyncSignModule', // 端网自动同签管理
        'mediaTagManagerModule', // 资源标签管理模块
        'manageconfigSysManagementJlglhModule', // 计量管理模块
    ])
    .controller('SysmanageController', [
        '$scope',
        '$element',
        '$state',
        'permissionService',
        '$timeout',
        '$q',
        'trsHttpService',
        'messagePublishService',
        'publicToolService',
        function($scope, $element, $state, permissionService, $timeout, $q, trsHttpService, messagePublishService, publicToolService) {
            // initStatus();

            // /**
            //  * [expandLevel2 description] 展开二级菜单
            //  * @param   {[type]}  moduleName  [moduleName description]
            //  * @return  {[type]}              [return description]
            //  */
            // $scope.expandLevel2 = function(moduleName) {
            //     $scope.status.expandedNodes[moduleName] = !$scope.status.expandedNodes[moduleName];
            // };

            // /**
            //  * [selectLevel2 description]
            //  *
            //  * @param   {[type]}  moduleName           [moduleName description]d
            //  * @param   {[type]}  notNarrowNavigation  [notNarrowNavigation description]d
            //  *
            //  * @return  {[type]}                       [return description]
            //  */
            // $scope.selectLevel2 = function(moduleName, notNarrowNavigation) {
            //     $scope.status.selectedModule = moduleName;
            //     $scope.$root.narrowNavigation = !notNarrowNavigation;
            // };
            // $scope.setSelectedOption = function(item, notNarrowNavigation) {
            //     if (item === 'NacosConfig'){
            //         const params = {
            //             serviceid: 'mlf_bigdata',
            //             methodName: 'getBigDataNacosConfigUrl'
            //         };
            //         trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
            //             window.open(data.DETAIL);                      
            //         });
            //     }
            //     $scope.status.selectedModule = item;
            //     $scope.$root.narrowNavigation = !notNarrowNavigation;
            // };
            // $scope.goToJlgl = function(item) {
            //     $scope.status.selectedModule = item;
            //     var url = $state.href('jlgl');
            //     window.open(url);
            // };

            // $scope.goToServerManage = function(item) {
            //     $scope.status.selectedModule = item;
            //     window.open(window.location.origin + '/toolkit/#/alltoolkit/navigation');
            // };

            // /**
            //  * [initStatus description]
            //  *
            //  * @return  {[type]}  [return description]
            //  */
            // function initStatus() {
            //     $scope.status = {
            //         selectedModule: $state.current.name.split('.')[2],
            //         expandedNodes: {},
            //         optionSelected: '',
            //     };
            //     if ($scope.status.selectedModule === 'cooperationgroup') {
            //         $scope.status.selectedModule = 'tenantsharemanuscript';
            //     }
            //     $scope.$root.narrowNavigation = true;
            //     $scope.assessExpand = false;
            //     isTenantAdministrator().then(function() {
            //         autoGo();
            //     });
            //     isAdministrator();
            //     publicToolService.getModeconfiguration('sysLeftShield', 'managementConfiguration').then((config) => {
            //         $scope.status.navigation = config;
            //     });
    
            // }

            // /**
            //  * [autoGo description] 自动跳转
            //  * @return {[type]} [description]
            //  */
            // function autoGo() {
            //     if ($state.current.name.split('.').length === 2) {
            //         $scope.$watch('configureAccess', function(newV) {
            //             if (newV && newV.system) {
            //                 $timeout(function() {
            //                     $element.find('ul li a')[0].click();
            //                 });
            //             }
            //         });
            //     } else if ($state.current.name.indexOf('hiddencodemanagement') >= 0) {
            //         $scope.status.selectedModule = $state.current.name.split('.')[3];
            //         $scope.status.expandedNodes.hiddencodemanagement = true;
            //         if ($state.current.name.indexOf('classifymanagement') >= 0) {
            //             $scope.$root.narrowNavigation = false;
            //         }
            //     } else if ($state.current.name.indexOf('peopleMark') >= 0) {
            //         $scope.assessExpand = true;
            //         $scope.status.selectedModule = 'peopleMark';
            //     } else if ($state.current.name.indexOf('placeMark') >= 0) {
            //         $scope.assessExpand = true;
            //         $scope.status.selectedModule = 'placeMark';
            //     } else if ($state.current.name.indexOf('eventMark') >= 0) {
            //         $scope.assessExpand = true;
            //         $scope.status.selectedModule = 'eventMark';
            //     }
            // }

            // /**
            //  * [isAdministrator description] 查询当前用户是不是系统管理员
            //  * @return {Boolean} [description]
            //  */
            // function isAdministrator() {
            //     permissionService.isAdministrator().then(function(data) {
            //         $scope.status.isAdministrator = data;
            //     });
            // }

            // /**
            //  * [isTenantAdministrator description] 查询当前用户是不是租户管理员
            //  * @return {Boolean} [description]
            //  */
            // function isTenantAdministrator() {
            //     var deffer = $q.defer();
            //     permissionService.isTenantAdministrator().then(function(data) {
            //         $scope.status.isTenantAdministrator = data;
            //         deffer.resolve();
            //     });
            //     return deffer.promise;
            // }
        },
    ]);
